import React, { useState } from "react";
import config from "../../../config";
import ApiDropdown from "../../DropDown/Apidropdown";
import Input from "../../input/input";
import "../Modal2.css";
import TextArea from "../../TextArea/TextArea";
import axios from "../../../utils/Security/axiosInstance";

type ConfirmCloseModalProps = {
  data: any;
  onConfirm: () => void;
  onCancel: () => void;
};

const ConfirmCloseModal: React.FC<ConfirmCloseModalProps> = ({
  data,
  onConfirm,
  onCancel,
}) => {
  const [incidentCloseDatetime, setIncidentCloseDatetime] = useState<string>(
    data.incidentCloseDatetime || ""
  );
  const [errorType, setErrorType] = useState<string>(data.errorType || "");
  const [closureCode, setClosureCode] = useState<string>(
    data.closureCode || ""
  );
  const [solution, setSolution] = useState<string>(data.solution || "");
  const [closedby, setClosedBy] = useState<string>(data.closedby || "");
  const [category, setCategory] = useState<string>(data.category || "");

  const storedUsername = localStorage.getItem("username");

  const handleConfirm = async () => {
    if (
      !incidentCloseDatetime.trim() ||
      !errorType.trim() ||
      !closureCode.trim() ||
      !solution.trim()
    ) {
      alert("Please fill in all required fields before confirming.");
      return;
    }

    // 🚨 NEW VALIDATION: close >= start
    if (
      data.incidentStartDatetime &&
      incidentCloseDatetime &&
      new Date(incidentCloseDatetime) < new Date(data.incidentStartDatetime)
    ) {
      alert(
        "Incident Close Date/Time cannot be earlier than Incident Start Date/Time."
      );
      return; // ❌ stop
    }
    try {
      const payload = {
        ticketId: data.ticketId,
        errorType,
        closureCode,
        solution,
        closedby: storedUsername || closedby,
        incidentCloseDatetime,
        category,
      };
      console.log(payload);

      const response = await axios.put(
        `${config.apiBaseUrl}/api/incidents/confirmclose`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      alert("Incident closed successfully!");
      onConfirm();
    } catch (error: any) {
      const message =
        error.response?.data || error.message || "Unknown error occurred.";
      alert(`Failed to close incident: ${message}`);
    }
  };

  return (
    <div
      className="modal-overlay"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
        padding: "1rem",
      }}
    >
      <div
        className="modal-content"
        style={{
          backgroundColor: "#fff",
          padding: "2rem 2.5rem",
          borderRadius: "12px",
          maxWidth: 450,
          width: "100%",
          boxShadow:
            "0 8px 24px rgba(0, 0, 0, 0.15), 0 2px 8px rgba(0, 0, 0, 0.1)",
          display: "flex",
          flexDirection: "column",
          gap: "1.5rem",
          fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        }}
      >
        <h2
          style={{
            margin: 0,
            fontWeight: "600",
            fontSize: "1.5rem",
            color: "#333",
          }}
        >
          Confirm Incident Close
        </h2>

        <Input
          type="datetime-local"
          label="Incident Close (UTC)"
          required
          value={incidentCloseDatetime}
          onChange={(val) => setIncidentCloseDatetime(val)}
          style={{ width: "100%" }}
        />

        <ApiDropdown
          api="Errors"
          labelKey="type"
          required
          valueKey="type"
          label="Error Type"
          value={errorType}
          onChange={(val) => setErrorType(String(val))}
        />

        <ApiDropdown
          api="ClosureCodes"
          labelKey="name"
          required
          valueKey="name"
          label="Closure Code"
          value={closureCode}
          onChange={(val) => setClosureCode(String(val))}
        />

        <TextArea
          label="Solution"
          value={solution}
          required
          onChange={(val) => setSolution(val)}
          style={{ width: "100%" }}
        />
        <ApiDropdown
          api="categories"
          labelKey="name"
          required
          valueKey="name"
          label="Category"
          value={category}
          onChange={(val) => setCategory(String(val))}
        />

        <Input
          label="Closed By "
          value={storedUsername || ""}
          required
          onChange={(val) => setClosedBy(val)}
          style={{ width: "100%" }}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "1rem",
            marginTop: "1rem",
          }}
        >
          <button
            onClick={onCancel}
            style={{
              padding: "0.5rem 1.2rem",
              borderRadius: "6px",
              border: "1px solid #ccc",
              backgroundColor: "#fff",
              color: "#444",
              cursor: "pointer",
              fontWeight: 500,
              transition: "background-color 0.2s ease",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = "#f0f0f0")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "#fff")
            }
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            style={{
              padding: "0.5rem 1.5rem",
              borderRadius: "6px",
              border: "none",
              backgroundColor: "#f97316",
              color: "white",
              cursor: "pointer",
              fontWeight: 600,
              boxShadow: "0 4px 8px rgba(249, 115, 22, 0.4)",
              transition: "background-color 0.2s ease",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = "#c4510b")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "#f97316")
            }
          >
            Yes, Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmCloseModal;
